module.exports = __webpack_public_path__ + "img/square_white.741f2501.svg";